module.exports = __webpack_public_path__ + "static/media/Arthur_Nguyen-Cao.cefbc0a0.jpg";